import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="forms--import-export-profile"
export default class extends Controller {
  static targets = ["profileInput"];
  static values = { profilesUrl: String };

  connect() {
    this.profileSelect = new TomSelect(this.profileInputTarget, {
      valueField: "id",
      labelField: "name",
      searchField: "name",
      preload: true,
      load: (query, callback) => {
        if (this.loading > 1) {
          callback();
          return;
        }

        fetch(this.profilesUrlValue)
          .then((response) => response.json())
          .then((json) => {
            callback(json);
          })
          .catch(() => {
            callback();
          });
      },
    });
  }
}
